module.exports = __webpack_public_path__ + "img/24.813842d8.jpg";